
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/api/kyc-aml-users",
      function () {
        return require("private-next-pages/docs/api/kyc-aml-users.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/api/kyc-aml-users"])
      });
    }
  